export enum ApiRoute {
  CEMETERIES_EXTENDED = '/cemeteries?extended=true',
  CATEGORIES = '/categories',
  ITEMS = '/items',
  ORDERS = '/orders',
  ORDERS_UNLOCATED_DECEASED = '/orders/unlocated-deceased',
}
